import React from "react";
import { motion } from "framer-motion";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaShieldAlt,
  FaUserTie,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quicklinks = [
    { name: "Home", url: "/" },
    { name: "About", url: "/about-us" },
    { name: "Services", url: "/Service" },
    { name: "Projects", url: "/Projects" },
    { name: "Contact", url: "/contact" },
  ];

  const support = [
    { name: "Contact Us", url: "/contact" },
    { name: "Terms & Conditions", url: "/terms" },
    { name: "Privacy Policy", url: "/privacy" },
  ];

  const contactInfo = [
    {
      icon: FaPhone,
      label: "Emergency Line",
      value: "+1 360-625-5045",
      href: "tel:+13606255045",
    },
    {
      icon: FaEnvelope,
      label: "Email Address",
      value: "info@mngcinc.com",
      href: "mailto:info@mngcinc.com",
    },
    {
      icon: FaMapMarkerAlt,
      label: "Service Area",
      value: "Washington State and Northern Idaho",
      href: "#map",
    },
  ];

  const certifications = [
    { icon: FaShieldAlt, text: "Licensed & Insured" },
    { icon: FaUserTie, text: "Expert Team" },
  ];

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, duration: 0.5 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="footer__container">
          <motion.div
            className="footer__grid"
            variants={container}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
          >
            {/* Brand */}
            <motion.div
              className="footer__column footer__column--brand"
              variants={item}
            >
              <div className="footer__brand">
                <div className="footer__logo">
                  <span className="footer__brandname">MNG Construction LLC</span>
                </div>
                <p className="footer__tagline">
                  Your trusted general contractor for ground-up builds,
                  renovations, and tenant improvements. We deliver safety-first,
                  code-compliant projects on schedule with comprehensive QA/QC
                  and seamless handovers.
                </p>

                <div className="footer__certifications">
                  {certifications.map((cert, i) => (
                    <div key={i} className="footer__certification">
                      <cert.icon className="certification__icon" />
                      <span>{cert.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>

            {/* Quick Links */}
            <motion.div
              className="footer__column footer__column--links"
              variants={item}
            >
              <h3 className="footer__title">Quick Links</h3>
              <ul className="footer__list" role="list">
                {quicklinks.map((link, i) => (
                  <li key={i} className="footer__item">
                    <a href={link.url} className="footer__link">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Support */}
            <motion.div
              className="footer__column footer__column--support"
              variants={item}
            >
              <h3 className="footer__title">Support</h3>
              <ul className="footer__list" role="list">
                {support.map((link, i) => (
                  <li key={i} className="footer__item">
                    <a href={link.url} className="footer__link">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>

            {/* Contact */}
            <motion.div
              className="footer__column footer__column--contact"
              variants={item}
            >
              <h3 className="footer__title">Contact Us</h3>
              <div className="footer__contacts">
                {contactInfo.map((contact, i) => (
                  <a
                    key={i}
                    href={contact.href}
                    className="footer__contact"
                    aria-label={contact.label}
                  >
                    <contact.icon className="contact__icon" />
                    <div className="contact__info">
                      <span className="contact__label">{contact.label}</span>
                      <span className="contact__value">{contact.value}</span>
                    </div>
                  </a>
                ))}
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer__bottom">
        <div className="footer__container">
          <div className="footer__copyright">
            <div className="copyright__content">
              <span>&copy; {currentYear} MNG Construction LLC.</span>
              <span>All rights reserved.</span>
              <span aria-hidden="true">|</span>
              <a href="https://connectrader.com/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
                Site By connectrader
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative BG */}
      <div className="footer__background">
        <div className="footer__pattern" />
      </div>
    </footer>
  );
};

export default Footer;
